/**
 * Copyright Mántum All Rights Reserved.
 */
import Button from './button';

export type PropTypes = {
    color?: string | null;
    disabled?: boolean;
    label: string;
    onChange?: (value: string | number) => void;
    selected?: boolean;
    type?: 'fat' | 'simple';
    value: string | number;
};

export default function Row(props: PropTypes) {
    // prettier-ignore
    const {
        selected = false
    } = props;

    const onClick = () => {
        if (props.onChange) {
            props.onChange(props.value);
        }
    };

    return (
        <Button
            active={selected}
            color={props.color}
            disabled={props.disabled}
            onClick={onClick}
            type={props.type}
        >
            {props.label}
        </Button>
    );
}
